
import { useCallback } from 'react';
import { useMarkAsReadMutation } from '../api';

export type UseMarkAsReadProps = {
    userId: string;
    onSuccess?: (notificationId: string) => void;
    onError?: (error: any) => void;
};

export function useMarkAsRead({ userId, onError }: UseMarkAsReadProps) {
    const [markAsReadMutation, { isLoading }] = useMarkAsReadMutation();

    const markAsRead = useCallback(async (notificationId: string) => {
        try {
            await markAsReadMutation({ notificationId, userId }).unwrap();
        } catch (error) {
            console.error('Error marking notification as read:', error);
            onError?.(error);
        }
    }, [markAsReadMutation, userId, onError]);

    return {
        markAsRead,
        isLoading
    };
}
